import React, {useState} from 'react';
import s from "../../../pages/LoginizationSteps/AutenticationStep/AutenticationStep.module.css";
import {zeroFill} from "../../../helpers/ZeroFill";
import {useNavigate} from "react-router-dom";

type TimerPropsType = {
    initialTimerValue: number,
}

const Timer = (props: TimerPropsType) => {

    const {
        initialTimerValue
    } = props

    const navigate = useNavigate()
    const [time, setTime] = useState(initialTimerValue)

    const tick = () => {
        if (time === 0) {
            navigate(-1)
            return
        }
        setTime(prevState => prevState - 1)
    }
    const minutes = Math.floor(time / 60);
    const seconds = time - minutes * 60;

    React.useEffect(() => {
        const timerID = setInterval(() => tick(), 1000);
        return () => clearInterval(timerID);
    });

    return (
        <div className={s.timer_wrapper}>
            <div> {zeroFill(minutes, 2)} : {zeroFill(seconds, 2)}</div>
        </div>
    );
};

export default Timer;
